import Backoffice from "@snark/backoffice"

// noinspection JSUnusedLocalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	return new (P || (P = Promise))(function (resolve, reject) {
		function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
};

const context = {
};

export default {
	name: "player",
	collection: "player",
	idProperty: "_id",
	section: "app",
	pagination: 50,
	backTextFilterList: true,
	labels: {"singleTitle":"Player","listTitle":"Players"},
	emptyItem: {"stat":{},"lastSeasonStats":null,"similarPlayers":[]},
	fields: [
		{
			name: "firstname",
			label: "Firstname",
		},
		{
			name: "lastname",
			label: "Lastname",
		},
		{
			name: "_id",
			label: "Id",
			readOnly: true,
			hideOnCreate: true,
		},
		{
			name: "invitationToken",
			label: "Invitation Token",
		},
		{
			name: "external_id",
			label: "External Id",
			editor: {type: "float"},
		},
		{
			name: "external_birthday",
			label: "External Birthday",
		},
		{
			name: "external_club_number",
			label: "External Club Number",
			editor: {type: "float"},
		},
		{
			name: "external_club_team_id",
			label: "External Club Team Id",
			editor: {type: "float"},
		},
		{
			name: "external_club_team_name",
			label: "External Club Team Name",
		},
		{
			name: "external_country1_id",
			label: "External Country1 Id",
			editor: {type: "float"},
		},
		{
			name: "external_country1_name",
			label: "External Country1 Name",
		},
		{
			name: "external_firstname",
			label: "External Firstname",
		},
		{
			name: "external_gender_id",
			label: "External Gender Id",
			editor: {type: "float"},
		},
		{
			name: "external_gender_name",
			label: "External Gender Name",
		},
		{
			name: "external_hand_id",
			label: "External Hand Id",
			editor: {type: "float"},
		},
		{
			name: "external_hand_name",
			label: "External Hand Name",
		},
		{
			name: "external_height",
			label: "External Height",
			editor: {type: "float"},
		},
		{
			name: "external_lastname",
			label: "External Lastname",
		},
		{
			name: "external_national_number",
			label: "External National Number",
			editor: {type: "float"},
		},
		{
			name: "external_national_team_id",
			label: "External National Team Id",
			editor: {type: "float"},
		},
		{
			name: "external_national_team_name",
			label: "External National Team Name",
		},
		{
			name: "external_photo",
			label: "External Photo",
		},
		{
			name: "external_position1_id",
			label: "External Position1 Id",
			editor: {type: "float"},
		},
		{
			name: "external_position1_name",
			label: "External Position1 Name",
		},
		{
			name: "external_position2_id",
			label: "External Position2 Id",
			editor: {type: "float"},
		},
		{
			name: "external_position2_name",
			label: "External Position2 Name",
		},
		{
			name: "email",
			label: "Email",
		},
		{
			name: "availabilities",
			label: "Availabilities",
			formatter: Backoffice.formatters.mapping({"available": "Available", "signed": "Signed", "ongoingNegotiations": "Ongoing Negotiations"}),
			editor: {type: "select", options: [{value: "available", label: "Available"}, {value: "signed", label: "Signed"}, {value: "ongoingNegotiations", label: "Ongoing Negotiations"}]},
		},
		{
			name: "phoneNumber",
			label: "Phone Number",
		},
		{
			name: "salary",
			label: "Salary",
			formatter: Backoffice.formatters.price(),
			editor: {type: "float", mode: "price"},
		},
		{
			name: "salaryGroup",
			label: "Salary Group",
		},
		{
			name: "computedSalaryGroup",
			label: "Computed Salary Group",
		},
		{
			name: "accommodation",
			label: "Accommodation",
			formatter: Backoffice.formatters.boolean(["Non", "Oui"]),
			editor: {type: "boolean", labels: ["Non", "Oui"]},
		},
		{
			name: "carFunction",
			label: "Car Function",
			formatter: Backoffice.formatters.boolean(["Non", "Oui"]),
			editor: {type: "boolean", labels: ["Non", "Oui"]},
		},
		{
			name: "agencyId",
			label: "Agency Id",
		},
		{
			name: "state",
			label: "State",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.mapping({"deleted": "Deleted", "draft": "Draft"}),
		},
		{
			name: "status",
			label: "Status",
			formatter: Backoffice.formatters.mapping({"invited": "Invited", "represented": "Represented", "free": "Free"}),
			editor: {type: "select", options: [{value: "invited", label: "Invited"}, {value: "represented", label: "Represented"}, {value: "free", label: "Free"}]},
		},
		{
			name: "stat",
			label: "Stat",
			children: [
				{
					name: "points",
					label: "Points",
					editor: {type: "float"},
				},
				{
					name: "twoPoints",
					label: "Two Points",
					editor: {type: "float"},
				},
				{
					name: "threePoints",
					label: "Three Points",
					editor: {type: "float"},
				},
				{
					name: "freeThrows",
					label: "Free Throws",
					editor: {type: "float"},
				},
				{
					name: "rebounds",
					label: "Rebounds",
					editor: {type: "float"},
				},
				{
					name: "assists",
					label: "Assists",
					editor: {type: "float"},
				},
				{
					name: "steal",
					label: "Steal",
					editor: {type: "float"},
				},
				{
					name: "blocks",
					label: "Blocks",
					editor: {type: "float"},
				},
			],
		},
		{
			name: "slug",
			label: "Slug",
		},
		{
			name: "lastSeasonId",
			label: "Last Season Id",
		},
		{
			name: "lastSeasonName",
			label: "Last Season Name",
		},
		{
			name: "lastSeasonStats",
			label: "Last Season Stats",
		},
		{
			name: "lastSeasonYear",
			label: "Last Season Year",
			editor: {type: "float"},
		},
		{
			name: "score",
			label: "Score",
			editor: {type: "float"},
		},
		{
			name: "lastSeasonMatchesCount",
			label: "Last Season Matches Count",
			editor: {type: "float"},
		},
		{
			name: "lastSeasonAgeCategory",
			label: "Last Season Age Category",
		},
		{
			name: "lastSeasonCompetitionType",
			label: "Last Season Competition Type",
		},
		{
			name: "lastSeasonGenderCategory",
			label: "Last Season Gender Category",
		},
		{
			name: "lastSeasonScope",
			label: "Last Season Scope",
		},
		{
			name: "lastSeasonTiersCategory",
			label: "Last Season Tiers Category",
		},
		{
			name: "lastSeasonTiersType",
			label: "Last Season Tiers Type",
		},
		{
			name: "similarPlayers",
			label: "Similar Players",
			list: true,
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "updatedAt",
			label: "Updated At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	listColumns: [
		{
			name: "external_id",
			label: "External Id",
		},
		{
			name: "external_club_team_id",
			label: "External Club Team Id",
		},
		{
			name: "external_club_team_name",
			label: "External Club Team Name",
		},
		{
			name: "external_firstname",
			label: "External Firstname",
		},
		{
			name: "external_lastname",
			label: "External Lastname",
		},
	],
	loadSingle() {
		return Promise.all([
		]);
	},
};